import React, { useState, useEffect, useRef } from 'react';
import { Container, Form, FormControl, ListGroup, Button, Table, Row, Col } from 'react-bootstrap';
import ApiService from 'services';
import ScoreCardView from 'components/scorecard';


function Head2Head() {
    const [options, setOptions] = useState([]);
    const [filterTextTeam1, setFilterTextTeam1] = useState('');
    const [filterTextTeam2, setFilterTextTeam2] = useState('');
    const [selectedOptionTeam1, setSelectedOptionTeam1] = useState(null);
    const [selectedOptionTeam2, setSelectedOptionTeam2] = useState(null);
    const [filteredOptionsTeam1, setFilteredOptionsTeam1] = useState(options);
    const [filteredOptionsTeam2, setFilteredOptionsTeam2] = useState(options);
    const [isDropdown1Open, setIsDropdown1Open] = useState(false);
    const [isDropdown2Open, setIsDropdown2Open] = useState(false);
    const team1DropdownRef = useRef(null);
    const team2DropdownRef = useRef(null);
    const [apiData, setApiData] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleFilterChange = (e, team) => {
        const searchText = e.target.value;
        if (team === 'team1') {
            setFilterTextTeam1(searchText);
            const filtered = options.filter((option) =>
                option.TeamName.toLowerCase().includes(searchText.toLowerCase())
            );
            setFilteredOptionsTeam1(filtered);
            setIsDropdown1Open(true);
            setIsDropdown2Open(false);
            
        } else if (team === 'team2') {
            setFilterTextTeam2(searchText);
            const filtered = options.filter((option) =>
                option.TeamName.toLowerCase().includes(searchText.toLowerCase())
            );
            setFilteredOptionsTeam2(filtered);
            setIsDropdown2Open(true);
            setIsDropdown1Open(false);
        }
    };

    const handleOptionClick = (option, team) => {
        if (team === 'team1') {
            setSelectedOptionTeam1(option);
            setFilterTextTeam1(option.TeamName);
            setFilteredOptionsTeam1(options);
        } else if (team === 'team2') {
            setSelectedOptionTeam2(option);
            setFilterTextTeam2(option.TeamName);
            setFilteredOptionsTeam2(options);
        }
        setIsDropdown1Open(false);
        setIsDropdown2Open(false);
    };

    const handleViewClick = async () => {
        if (selectedOptionTeam1 && selectedOptionTeam2) {
            try {
                const response = await ApiService.getHead2Head(selectedOptionTeam1.TeamId, selectedOptionTeam2.TeamId);
                // Handle the response from the API call
                console.log(response);
                setApiData(response);
                setLoading(false);
            } catch (error) {
                // Handle error
            }
        }
    };

    const handleOutsideClick = (e) => {
        if (
            team1DropdownRef.current &&
            !team1DropdownRef.current.contains(e.target) &&
            team2DropdownRef.current &&
            !team2DropdownRef.current.contains(e.target)
        ) {
            setIsDropdown1Open(false);
            setIsDropdown2Open(false);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await ApiService.getTeams();
                setOptions(response);
            } catch (error) {
                // Handle error
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);



    const getUIForScoreTable = () => {
        return <Table responsive striped bordered hover className='p-1'>
            <thead>
                <tr>
                    <th>Recent Matches</th>
                </tr>
            </thead>
            <tbody>

                {apiData.Scores && apiData.Scores.length > 0 && apiData.Scores.map((oneMatchScore, index) => {

                    return (
                        <tr key={index}>
                            <td>
                                <ScoreCardView matchData={oneMatchScore} />
                            </td>
                        </tr>
                    )

                })}

            </tbody>
        </Table>

    };
    return (
        <Container className="mt-5">
            <Row className='mb-2'>
                <Col xs={12} md={{ offset: 2, span: 8 }} >

                    <h1>Head To Head Analysis</h1>
                    <Form>
                        <Form.Group controlId="formSelect">
                            <div className="d-flex align-items-center p-2">
                                <Form.Label className="mr-2">Team 1</Form.Label>
                                <div ref={team1DropdownRef} className="position-relative">
                                    <FormControl
                                        type="text"
                                        placeholder="Search..."
                                        value={filterTextTeam1}
                                        onChange={(e) => handleFilterChange(e, 'team1')}
                                        onClick={() => setIsDropdown1Open(true)}
                                        autoComplete='off'
                                    />
                                    {isDropdown1Open && filteredOptionsTeam1.length > 0 && (
                                        <ListGroup className="position-absolute w-100 border rounded" style={{zIndex:"1000"}}>
                                            {filteredOptionsTeam1.map((option, index) => (
                                                <ListGroup.Item
                                                    key={index}
                                                    action
                                                    onClick={() => handleOptionClick(option, 'team1')}
                                                    active={selectedOptionTeam1 === option}
                                                >
                                                    {option.TeamName}
                                                </ListGroup.Item>
                                            ))}
                                        </ListGroup>
                                    )}
                                </div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="formSelect">
                            <div className="d-flex align-items-center p-2">
                                <Form.Label className="mr-2">Team 2</Form.Label>
                                <div ref={team2DropdownRef} className="position-relative">
                                    <FormControl
                                        type="text"
                                        placeholder="Search..."
                                        value={filterTextTeam2}
                                        onChange={(e) => handleFilterChange(e, 'team2')}
                                        onClick={() => setIsDropdown2Open(true)}
                                        autoComplete='off'
                                    />
                                    {isDropdown2Open && filteredOptionsTeam2.length > 0 && (
                                        <ListGroup className="position-absolute w-100 bg-white border rounded" style={{zIndex:"1000"}}>
                                            {filteredOptionsTeam2.map((option, index) => (
                                                <ListGroup.Item
                                                    key={index}
                                                    action
                                                    onClick={() => handleOptionClick(option, 'team2')}
                                                    active={selectedOptionTeam2 === option}
                                                >
                                                    {option.TeamName}
                                                </ListGroup.Item>
                                            ))}
                                        </ListGroup>
                                    )}
                                </div>
                            </div>
                        </Form.Group>
                        <Button variant="primary" className="mb-1" onClick={handleViewClick}>
                            View
                        </Button>
                    </Form>
                </Col>
            </Row>
            {!loading && <>
                {getUIForScoreTable()}
            </>}
        </Container>
    );
}

export default Head2Head;
